import gql from 'graphql-tag'

export default gql`
  query getWorkflowHistory($projectId: String!, $workflowId: String!, $version: Int!) {
    getWorkflowHistory(projectId: $projectId, workflowId: $workflowId, version: $version) {
      id
      version
      dataModels {
        id
        name
        type
        boundedContext
        cardId
        dataFields {
          name
          cardinality
          primaryKey
          exampleData
        }
      }
      eventsJson {
        id
        description
        type
        requirementsJson {
          id
          cardTypeId
          cardType {
            aggregateType
            triggerType
            queryType
            gwtType
            title
          }
          entityId
          description
          cardinality
        }
        dataModels {
          id
          name
          type
          boundedContext
          cardId
          dataFields {
            name
            cardinality
            primaryKey
            exampleData
          }
        }
      }
    }
  }
`
